import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionIdService {
  private readonly defaultSessionKey = 'blankmileSessionId';

  getOrCreateSessionId(storageKey: string = this.defaultSessionKey): string {
    let sessionId = sessionStorage.getItem(storageKey);
    if (!sessionId) {
      sessionId =
        typeof crypto !== 'undefined' && 'randomUUID' in crypto
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      sessionStorage.setItem(storageKey, sessionId);
    }
    return sessionId;
  }

  clearSessionId(storageKey: string = this.defaultSessionKey): void {
    sessionStorage.removeItem(storageKey);
  }
}
